(() => {
    'use strict';

    const isNPS = function(widget) {
        return widget.data('scale-type') === howspace.widgets.pulse.SCALE_TYPE_NPS;
    }

    const loadResults = function(widget, readyFn) {
        const dataPayload = {
            filter: howspace.widgets.getFilter(widget),
            sort_order: widget.data('answers-sort-order'),
            compare: widget.data('compare-results-to')
        };

        real.ajax.json(howspace.widgets.getUrl(widget) + '/results', {
            type : 'GET',
            data : dataPayload,
            success : function(response) {
                readyFn(response);
            }
        });
    };

    const renderResults = function(widget, results, readyFn) {
        if (isNPS(widget)) {
            // Latest round results.
            if (results.latest_round) {
                const resultsWrapper = widget.find('.nps-latest-round-wrapper');
                resultsWrapper.find('.nps-score').text(results.latest_round.chart_data.score);
                resultsWrapper.find('canvas').dataAndAttr('chart-data', results.latest_round.chart_data);

                drawNPSLatestRoundChart(widget);
            }

            // Follow-up results.
            if (results.follow_up) {
                const resultsWrapper = widget.find('.nps-follow-up-wrapper');
                resultsWrapper.find('canvas').dataAndAttr('chart-data', results.follow_up.chart_data);

                drawNPSFollowUpChart(widget);
            }
        } else {
            // Latest round results.
            if (results.latest_round) {
                const resultsWrapper = widget.find('.latest-round-wrapper');
                const myAnswersSelected = resultsWrapper.find('.my-answer-badge').hasClass('selected');

                if (results.latest_round.questions) {
                    resultsWrapper.removeClass('hidden');
                } else {
                    resultsWrapper.addClass('hidden');
                }

                // update legend
                for (const filter of results.filters) {
                    const badge = resultsWrapper.find('.legend .filter-badge[data-filter-value="' + filter.value + '"]');
                    badge.text(filter.name + ' (' + filter.users_count + ')');
                }

                // update question average sliders
                Object.entries(results.latest_round.questions || {}).forEach(([id, data]) => {
                    Object.entries(data.average || {}).forEach(([filterValue, value]) => {
                        const slider = resultsWrapper.find('.question[data-id="' + id + '"] .data[data-filter-value="' + filterValue + '"] .average .howspace-slider');
                        howspace.components.slider.setValue(slider, value, value !== null);
                    });
                });

                // update question my answer sliders
                Object.entries(results.latest_round.my_answers || {}).forEach(([id, value]) => {
                    const slider = resultsWrapper.find('.question[data-id="' + id + '"] .my-answer .howspace-slider');
                    howspace.components.slider.setValue(slider, value, value !== null);
                });

                // update total average slider
                Object.entries(results.latest_round.average || {}).forEach(([filterValue, value]) => {
                    const slider = resultsWrapper.find('.question[data-id=""] .data[data-filter-value="' + filterValue + '"] .average .howspace-slider');
                    howspace.components.slider.setValue(slider, value, value !== null);
                });

                // update my answer average slider
                if (results.latest_round.my_average) {
                    const slider = resultsWrapper.find('.question[data-id=""] .my-answer .howspace-slider');
                    const value = results.latest_round.my_average;
                    howspace.components.slider.setValue(slider, value, value !== null);
                }

                // update question distributions
                Object.entries(results.latest_round.questions || {}).forEach(([id, data]) => {
                    Object.entries(data.distribution_view || {}).forEach(([filterValue, value]) => {
                        const distribution = resultsWrapper.find('.question[data-id="' + id + '"] .data[data-filter-value="' + filterValue + '"] .distribution');
                        distribution.dataAndAttr('distribution', value);

                        const keys = Object.keys(value);
                        distribution.find('.bar').each(function (index) {
                            const key = keys[index];
                            const height = value[key]?.height_percentage ?? 0;

                            $(this).css('height', height + '%');
                        });
                    });
                });

                // update total average distribution
                if (results.latest_round.distribution_view) {
                    Object.entries(results.latest_round.distribution_view || {}).forEach(([filterValue, value]) => {
                        const distribution = resultsWrapper.find('.question[data-id=""] .data[data-filter-value="' + filterValue + '"] .distribution');
                        distribution.dataAndAttr('distribution', value);

                        const keys = Object.keys(value);
                        distribution.find('.bar').each(function (index) {
                            const key = keys[index];
                            const height = value[key]?.height_percentage ?? 0;

                            $(this).css('height', height + '%');
                        });
                    });
                }

                howspace.components.init(resultsWrapper);

                if (results.latest_round.chart_data?.radar) {
                    const radar = resultsWrapper.find('.radar');
                    radar.find('canvas').dataAndAttr('chart-data', results.latest_round.chart_data.radar);
                }

                drawLatestRoundCharts(widget);

                if (myAnswersSelected) {
                    resultsWrapper.find('.my-answer-badge').trigger('click');
                }
            }

            // Follow-up results.
            if (results.follow_up) {
                const resultsWrapper = widget.find('.follow-up-wrapper');

                if (results.follow_up.chart_data) {
                    resultsWrapper.removeClass('hidden');
                } else {
                    resultsWrapper.addClass('hidden');
                }

                Object.entries(results.follow_up.answer_counts || {}).forEach(([id, data]) => {
                    const alert = resultsWrapper.find(`.answering-round-alert[data-id="${id}"]`);
                    const answers = alert.find('.answers');
                    const count = data.all;
                    if (count === 1) {
                        answers.text('(' + howspace.translate('pulse_answer', { count: count }) + ')');
                    } else {
                        answers.text('(' + howspace.translate('pulse_answers', { count: count }) + ')');
                    }
                });

                real.loop(results.follow_up.chart_data?.questions || {}, function(chartData, questionId) {
                    const question = resultsWrapper.find('.question[data-id="' + questionId + '"]');
                    question.find('canvas').dataAndAttr('chart-data', chartData);
                });

                if (results.follow_up.chart_data?.total) {
                    const totalAverage = resultsWrapper.find('.total-average');
                    totalAverage.find('canvas').dataAndAttr('chart-data', results.follow_up.chart_data.total);
                }

                real.loop(results.follow_up.chart_data?.radar || {}, function(chartData, filterValue) {
                    const radar = resultsWrapper.find('.radar[data-filter="' + filterValue + '"]');
                    radar.find('canvas').dataAndAttr('chart-data', chartData);
                });

                drawFollowUpCharts(widget);
            }
        }

        widget.addClass('has-answers');

        if (typeof readyFn === 'function') {
            readyFn();
        }
    };

    const updateResultsView = (widget, readyFn) => {
        loadResults(widget, (results) => {
            renderResults(widget, results, readyFn);
        });
    };

    const deleteAnswer = (widget, successFn) => {
        const url = howspace.widgets.getApiUrl(widget)
            + '/answeringround/'
            + widget.data('active-answering-round-id')
            + '/answer/'
            + widget.data('user-answer-id-to-active-answering-round')
        ;

        real.ajax.json(url, {
            type : 'DELETE',
            success : successFn
        });
    };

    const submitAnswer = (widget, successFn) => {
        const dataPayload = {
            pulse_question_values : getQuestionAnswers(widget)
        };

        let url = howspace.widgets.getApiUrl(widget)
            + '/answeringround/'
            + widget.data('active-answering-round-id')
        ;

        const answerId = widget.data('user-answer-id-to-active-answering-round');
        if (answerId) {
            url += '/answer/' + answerId;
        } else {
            url += '/answers';
        }

        real.ajax.json(url, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success : (response) => {
                successFn(response);
            },
            logError : response => {
                return response.status !== 409;
            },
            showErrorNotification : response => {
                return response.status !== 409;
            },
            error : response => {
                real.ajax.loopErrors(response, function(error) {
                    if (error.code === 409) {
                        // User has already answered to pulse, but UI didn't update fast enough and now
                        // user is trying to answer again and conflict occurred. Just update the
                        // whole widget UI at this point.
                        howspace.widgets.updateWidget(widget, 'view');
                    }
                });
            }
        });
    };

    const updateLegend = (e) => {
        const range = $(e.currentTarget).parent();
        const widget = range.closest('.widget');
        const scaleType = range.data('scale-type');
        const leftValue = parseInt(range.find('.howspace-range-input-left').val());
        const rightValue = parseInt(range.find('.howspace-range-input-right').val());

        // hide all legend items
        widget.find('.legend-item[data-scale-type="' + scaleType + '"]').addClass('d-none');

        // show legend items for the current range
        for (let i = leftValue; i <= rightValue; i++) {
            widget.find('.legend-item[data-scale-type="' + scaleType + '"][data-index="' + i + '"]').removeClass('d-none');
        }
    };

    const getQuestionAnswers = widget => {
        const submitBtn = widget.find('.submit-btn');
        submitBtn.prop('disabled', false);

        const answers = {};
        widget.find('.options-wrapper .question').each(function() {
            const question = $(this);
            const id = '_' + question.data('id');
            const slider = question.find('.howspace-slider');

            if (howspace.components.slider.isDeselected(slider)) {
                submitBtn.prop('disabled', true);
            } else {
                answers[id] = parseInt(slider.find('.howspace-slider-input').val());
            }
        });
        return answers;
    };

    const setSelectedAnswers = widget => {
        const key = `${widget.data('active-answering-round-id')}-selected-answers`;
        howspace.widgets.setLocalStorage(widget, key, getQuestionAnswers(widget));
    };

    const removeSelectedAnswers = widget => {
        const key = `${widget.data('active-answering-round-id')}-selected-answers`;
        howspace.widgets.removeLocalStorage(widget, key);

        widget.find('.options-wrapper .question .howspace-slider').each(function() {
            const slider = $(this);
            const minValue = slider.find('input').prop('min');
            howspace.components.slider.setValue(slider, minValue, false);
        });
    };

    const getSelectedAnswers = widget => {
        const key = `${widget.data('active-answering-round-id')}-selected-answers`;
        const answers = howspace.widgets.getLocalStorage(widget, key);

        if (answers) {
            let submitDisabled = false;

            widget.find('.options-wrapper .question').each(function() {
                const question = $(this);
                const id = '_' + question.data('id');
                const value = answers[id];

                if (value !== undefined) {
                    question.find('.howspace-slider-input').val(value).trigger('input');
                } else {
                    submitDisabled = true;
                }
            });

            widget.find('.submit-btn').prop('disabled', submitDisabled);
        }
    };

    const drawChart = (widget, elem) => {
        if (elem.length === 0) {
            // Element not found, no need to draw chart.
            return;
        }

        const datasets = [];
        const canvas = elem.find('canvas');
        const chart = elem.data('chart');

        const chartData = canvas.data('chart-data');

        if (chart) {
            chart.destroy();
        }

        if (chartData.averages) {
            const bodyComputedCss = window.getComputedStyle(document.body, null);
            const backupAverageBgColor = bodyComputedCss.getPropertyValue(widget.data('average-bg-color'));
            const backupAverageBorderColor = bodyComputedCss.getPropertyValue(widget.data('average-border-color'));

            for (let i = 0; i < chartData.averages.length; i++) {
                datasets.push({
                    label : chartData.labels[i],
                    backgroundColor : chartData.colors?.[i] ?? backupAverageBgColor,
                    borderColor : chartData.colors?.[i] ?? backupAverageBorderColor,
                    data : chartData.averages[i],
                    fill : false,
                    spanGaps : true,
                    lineTension : 0.2
                });
            }
        }

        // Chart is not drawn yet.
        if (chartData.my_answers) {
            datasets.push({
                label : howspace.translate('pulse_my_answer'),
                backgroundColor : howspace.widgets.pulse.MY_ANSWER_BACKGROUND_COLOR,
                borderColor : howspace.widgets.pulse.MY_ANSWER_BORDER_COLOR,
                data : chartData.my_answers,
                fill : false,
                spanGaps : true,
                lineTension : 0.2
            });
            canvas.dataAndAttr('my-answers', chartData.my_answers);
        } else {
            const myAnswers = canvas.data('my-answers');
            if (myAnswers) {
                datasets.push({
                    label : howspace.translate('pulse_my_answer'),
                    backgroundColor : howspace.widgets.pulse.MY_ANSWER_BACKGROUND_COLOR,
                    borderColor : howspace.widgets.pulse.MY_ANSWER_BORDER_COLOR,
                    data : myAnswers,
                    fill : false,
                    spanGaps : true,
                    lineTension : 0.2
                });
            }
        }

        let yLabelString = howspace.translate('pulse_scale');
        if ((widget.data('scale-from') === 0) && (widget.data('scale-to') === 100)) {
            yLabelString = howspace.translate('pulse_scale_percentage');
        }

        const chartOptions = {
            type: 'line',
            data: {
                labels: chartData.x_labels,
                datasets: datasets
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    title: { display: false },
                    legend: {
                        position: 'top',
                        labels: {
                            usePointStyle: true
                        }
                    },
                    tooltip: {
                        callbacks: {
                            title: (tooltipItems) => {
                                return howspace.translate('pulse_round') + ' ' + tooltipItems[0].label;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: howspace.translate('pulse_rounds'),
                        },
                        position: 'bottom'
                    },
                    y: {
                        title: {
                            display: true,
                            text: yLabelString,
                        },
                        position: 'left',
                        min: widget.data('scale-from'),
                        max: widget.data('scale-to'),
                        ticks: {
                            stepSize: chartData.stepSize,
                            precision: 0
                        }
                    }
                }
            }
        };

        const newChart = new Chart(canvas[0].getContext('2d'), chartOptions);
        elem.data('chart', newChart);
        howspace.chart.renderAccessibleTable(canvas, newChart);
    };

    const drawLatestRoundCharts = widget => {
        drawRadarChart(widget, widget.find('.latest-round-wrapper .radar'));
    };

    const drawFollowUpCharts = (widget) => {
        widget.find('.follow-up-wrapper .question').each(function() {
            drawChart(widget, $(this));
        });

        widget.find('.follow-up-wrapper .radar').each(function() {
            drawRadarChart(widget, $(this));
        });
    };

    const updateNPSChart = (elem, readyFn) => {
        if (elem.data('update-results-timeout-id')) {
            clearTimeout(elem.data('update-results-timeout-id'));
        }

        elem.data('update-results-timeout-id', setTimeout(() => {
            elem.removeData('update-results-timeout-id');

            if (readyFn) {
                readyFn();
            }
        }, 100));
    };

    const drawNPSLatestRoundChart = (widget) => {
        const elem = widget.find('.nps-latest-round-wrapper');
        if (elem.length === 0) {
            return;
        }

        const canvas = elem.find('canvas');
        const chart = elem.data('chart');
        const results = canvas.data('chart-data');

        const chartData = {
            labels : results.distribution.map(row => row.answer),
            datasets : [
                {
                    label: howspace.translate('pulse_scale_percentage'),
                    data: results.distribution.map(row => row.percentage),
                    backgroundColor : results.distribution.map(row => row.color)
                }
            ]
        };

        const chartOptions = {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 1.33,
            plugins: {
                title: { display: false },
                legend: { display: false }
            },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: 'n=' + results.n,
                    },
                    position: 'bottom'
                },
                y: {
                    ticks: {
                        beginAtZero: true,
                        suggestedMax: 45
                    },
                    title: {
                        display: true,
                        text: howspace.translate('pulse_scale_nps'),
                    },
                    position: 'left'
                }
            }
        };

        const npsTableOptions = {
            valueHeader: howspace.translate('pulse_scale_nps'),
            formatValue: value => Math.round(value) + '%',
        };

        const wasVisible = elem.is(':visible');
        elem.show();

        if (chart) {
            updateNPSChart(elem, () => {
                chart.data = chartData;
                chart.options = chartOptions;

                chart.update();
                howspace.chart.renderAccessibleTable(canvas, chart, npsTableOptions);

                if (!wasVisible) {
                    elem.hide();
                }
            });
        } else {
            const options = {
                type : 'bar',
                data : chartData,
                options : chartOptions
            }
            const newChart = new Chart(canvas[0].getContext('2d'), options);
            elem.data('chart', newChart);
            howspace.chart.renderAccessibleTable(canvas, newChart, npsTableOptions);
        }
    };

    const drawNPSFollowUpChart = (widget) => {
        const elem = widget.find('.nps-follow-up-wrapper');
        if (elem.length === 0) {
            return;
        }

        const canvas = elem.find('canvas');
        const chart = elem.data('chart');
        const results = canvas.data('chart-data');
        const color = getComputedStyle(document.documentElement).getPropertyValue('--hs-btn-primary-bg-color');

        const chartData = {
            labels: results.labels,
            datasets: [
                {
                    label: howspace.translate('pulse_scale_nps_follow_up'),
                    data: results.score,
                    backgroundColor: color,
                    fill: false,
                    spanGaps: true,
                    tension: 0.2
                }
            ]
        };

        const chartOptions = {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
                title: { display: false },
                legend: { display: false }
            },
            scales: {
                x: {
                    title: {
                        display: false
                    },
                    position: 'bottom'
                },
                y: {
                    ticks: {
                        suggestedMax: 100,
                        suggestedMin: -100
                    },
                    title: {
                        display: true,
                        text: howspace.translate('pulse_scale_nps_follow_up'),
                    },
                    position: 'left'
                }
            }
        };

        if (chart) {
            updateNPSChart(elem, () => {
                chart.data = chartData;
                chart.options = chartOptions;

                chart.update();
                howspace.chart.renderAccessibleTable(canvas, chart);
            });
        } else {
            const options = {
                type : 'line',
                data : chartData,
                options : chartOptions
            }
            const newChart = new Chart(canvas[0].getContext('2d'), options);
            elem.data('chart', newChart);
            howspace.chart.renderAccessibleTable(canvas, newChart);
        }
    };

    const drawRadarChart = (widget, elem) => {
        if (elem.length === 0) {
            // Element not found, no need to draw chart.
            return;
        }

        const datasets = [];
        const canvas = elem.find('canvas');
        const chart = elem.data('chart');
        const chartData = canvas.data('chart-data');

        const labels = [];
        widget.find('.pulse-question-radar-chart-translations .pulse-question:not(.removing)').each(function() {
            labels.push($(this).text());
        });

        if (chart) {
            chart.destroy();
        }

        if (chartData.averages) {
            for (let i = 0; i < chartData.averages.length; i++) {
                datasets.push({
                    label: chartData.labels[i],
                    backgroundColor: chartData.background_colors[i] ?? widget.data('average-bg-color'),
                    borderColor: chartData.border_colors[i] ?? widget.data('average-border-color'),
                    data: chartData.averages[i],
                    fill: true,
                    spanGaps: true,
                    tension: 0.2
                });
            }
        }

        if (chartData.my_answers) {
            datasets.push({
                label: howspace.translate('pulse_my_answer'),
                backgroundColor: howspace.widgets.pulse.RADAR_MY_ANSWER_BACKGROUND_COLOR,
                borderColor: howspace.widgets.pulse.MY_ANSWER_BORDER_COLOR,
                data: chartData.my_answers,
                fill: true,
                spanGaps: true,
                tension: 0.2
            });
            canvas.dataAndAttr('my-answers', chartData.my_answers);
        } else {
            const myAnswers = canvas.data('my-answers');
            if (myAnswers) {
                datasets.push({
                    label: howspace.translate('pulse_my_answer'),
                    backgroundColor: howspace.widgets.pulse.RADAR_MY_ANSWER_BACKGROUND_COLOR,
                    borderColor: howspace.widgets.pulse.MY_ANSWER_BORDER_COLOR,
                    data: myAnswers,
                    fill: true,
                    spanGaps: true,
                    tension: 0.2
                });
            }
        }

        const chartOptions = {
            type: 'radar',
            data: {
                labels: labels,
                datasets: datasets
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    title: { display: false },
                    legend: {
                        position: 'top',
                        labels: {
                            usePointStyle: true
                        }
                    }
                },
                scales: {
                    r: {
                        angleLines: {
                            color: 'rgba(0, 0, 0, 0.25)'
                        },
                        grid: {
                            color: 'rgba(0, 0, 0, 0.25)'
                        },
                        min: chartData.scale.min,
                        max: chartData.scale.max,
                        ticks: {
                            stepSize: chartData.scale.stepSize
                        },
                        pointLabels: {
                            font: {
                                size: 14
                            },
                            callback: function(label, index) {
                                return howspace.splitTextToLines(label);
                            }
                        }
                    }
                }
            }
        };

        const newChart = new Chart(canvas[0].getContext('2d'), chartOptions);
        elem.data('chart', newChart);
        howspace.chart.renderAccessibleTable(canvas, newChart);
    };

    const toggleLatestRoundAverage = (e) => {
        const badge = $(e.target);
        const widget = badge.closest('.widget');

        badge.toggleClass('selected');
        badge.attr('aria-pressed', badge.hasClass('selected') ? 'true' : 'false');

        widget.find('.latest-round-wrapper .question .average').toggleClass('d-none');
    };

    const toggleLatestRoundMyAnswer = (e) => {
        const badge = $(e.target);
        const widget = badge.closest('.widget');

        badge.toggleClass('selected');
        badge.attr('aria-pressed', badge.hasClass('selected') ? 'true' : 'false');

        widget.find('.latest-round-wrapper .question .my-answer').toggleClass('d-none');
    };

    const toggleFilterAverage = (e) => {
        const badge = $(e.target);
        const filterValue = badge.data('filter-value');
        const widget = badge.closest('.widget');

        badge.toggleClass('selected');
        badge.attr('aria-pressed', badge.hasClass('selected') ? 'true' : 'false');

        widget.find('.latest-round-wrapper .question .data[data-filter-value="' + filterValue + '"]').toggleClass('d-none');
    };

    // Answer events.
    const onAnswerEvent = (action, fn) => {
        howspace.widgets.onEvent('pulse:answeringround:answer:' + action, (widget, notification) => {
            fn(widget, notification);
        });
    };

    onAnswerEvent('created', (widget, notification) => {
        widget.dataAndAttr('user-answer-id-to-active-answering-round', notification.object.pulse_answering_round_answer.id);
        showResultsView(widget);
        howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
    });

    onAnswerEvent('deleted', (widget, notification) => {
        widget.removeDataAndAttr('user-answer-id-to-active-answering-round');
        widget.find('.delete-answer-btn').addClass('d-none');
        removeSelectedAnswers(widget);
        changeView(widget, ['.options-wrapper'], ['.text-wrapper', '.results-wrapper']);
        howspace.workspace.page.pathMode.handleUserHasNotInteracted(widget);
    });

    howspace.widgets.onEvent('pulse:results:updated', (widget, notification) => {
        if (widget.find('.save-filters-btn:visible').length === 0) {
            // Only switch to the configured results view if the user has already answered,
            // but the results view is not yet shown.
            if (
                widget.data('user-answer-id-to-active-answering-round') &&
                widget.find('.results-wrapper').hasClass('d-none')
            ) {
                showResultsView(widget);
            }
            renderResults(widget, notification.object.results);
        }
    });

    const changeView = (widget, show, hide) => {
        show.forEach((selector) => {
            widget.find(selector).removeClass('d-none');
        });

        hide.forEach((selector) => {
            widget.find(selector).addClass('d-none');
        });
    };

    const showResultsView = (widget) => {
        widget.find('.latest-round-wrapper').removeClass('hidden');
        widget.find('.follow-up-wrapper').removeClass('hidden');

        switch (widget.data('results-type')) {
            case 'latest_round':
                changeView(widget, ['.results-wrapper'], ['.text-wrapper', '.options-wrapper'])
                changeView(widget, ['.latest-round-wrapper'], ['.follow-up-wrapper']);
                break;
            case 'follow_up':
                changeView(widget, ['.results-wrapper'], ['.text-wrapper', '.options-wrapper'])
                changeView(widget, ['.follow-up-wrapper'], ['.latest-round-wrapper']);
                break;
            case 'results_text':
                changeView(widget, ['.text-wrapper'], ['.results-wrapper', '.options-wrapper'])
                break;
        }

        const changeAnswerBtn = widget.find('.change-answer-btn');
        real.button.reset(changeAnswerBtn);
        changeAnswerBtn.removeClass('d-none');

        const deleteAnswerBtn = widget.find('.delete-answer-btn');
        real.button.reset(deleteAnswerBtn);
        deleteAnswerBtn.removeClass('d-none');
    };

    const initDistributionModal = (modal, modalOpener) => {
        modal = $(modal);

        const distributionArray = modalOpener.data('distribution');
        let color = modalOpener.data('color');
        const widget = modalOpener.closest('.widget');
        const scaleFrom = parseInt(widget.data('scale-from'));
        const scaleTo = parseInt(widget.data('scale-to'));

        if (color.startsWith('var')) {
            color = getComputedStyle(widget[0]).getPropertyValue(color.replace('var(', '').replace(')', ''));
        }

        let
            labels = [],
            data = [],
            colors = []
        ;

        if (widget.data('scale-type') === 'percentage') {
            real.loop(distributionArray, (value, label) => {
                labels.push(label);
                data.push(value.count);
                colors.push(color);
            });
        } else {
            for (let i = scaleFrom; i <= scaleTo; i++) {
                labels.push(i);
                data.push(distributionArray[i].count);
                colors.push(color);
            }
        }

        const chartOptions = {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    backgroundColor: colors,
                    data: data
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    title: { display: false },
                    legend: { display: false }
                },
                scales: {
                    x: {
                        display: true,
                        ticks: {
                            autoSkip: false,
                            beginAtZero: false
                        },
                        type: 'category'
                    },
                    y: {
                        display: true,
                        ticks: {
                            beginAtZero: true,
                            callback: function (value) {
                                if (value % 1 === 0) {
                                    return value;
                                }
                            }
                        }
                    }
                }
            }
        };

        modal.find('h4').text(modalOpener.data('title'));

        const canvas = modal.find('canvas');
        canvas.height(canvas.width() / 2);

        const chart = new Chart(canvas[0].getContext('2d'), chartOptions);
        howspace.chart.renderAccessibleTable(canvas, chart, {
            caption: modalOpener.data('title'),
            labelHeader: howspace.translate('pulse_scale'),
            valueHeader: howspace.translate('pulse_distribution'),
            formatValue: value => value === 1
                ? howspace.translate('pulse_answer', {count: value})
                : howspace.translate('pulse_answers', {count: value}),
        });
    };

    howspace.widgets.pulse = {
        SCALE_TYPE_POSITIVE : 'positive',
        SCALE_TYPE_NEGATIVE_TO_POSITIVE : 'negative_to_positive',
        SCALE_TYPE_PERCENTAGE : 'percentage',
        SCALE_TYPE_NPS : 'nps',
        MY_ANSWER_BACKGROUND_COLOR : '#888',
        MY_ANSWER_BORDER_COLOR : '#888',
        RADAR_MY_ANSWER_BACKGROUND_COLOR : 'rgba(88, 88, 88, 0.35)',
        initView: widget => {
            // Initialize charts.
            howspace.chart.init(() => {
                if ($('.latest-round-wrapper').is(':visible')) {
                    if (isNPS(widget)) {
                        drawNPSLatestRoundChart(widget);
                    } else {
                        drawLatestRoundCharts(widget);
                    }
                } else if ($('.follow-up-wrapper').is(':visible')) {
                    if (isNPS(widget)) {
                        drawNPSFollowUpChart(widget);
                    } else {
                        drawFollowUpCharts(widget);
                    }
                }
                widget.on(howspace.components.translator.TRANSLATION_COMPLETED, '.pulse-question-radar-chart-translations', () => {
                    const questionsCount = widget.find('.pulse-question-translations .pulse-question:not(.removing)').length;
                    const translateQuestionsCount = widget.find('.pulse-question-translations .pulse-question.translated:not(.removing)').length;
                    if (questionsCount === translateQuestionsCount) {
                        // All questions translated, redraw the charts.
                        if ($('.latest-round-wrapper').is(':visible') && !isNPS(widget)) {
                            drawLatestRoundCharts(widget);
                        } else if ($('.follow-up-wrapper').is(':visible') && !isNPS(widget)) {
                            drawFollowUpCharts(widget);
                        }
                    }
                });
            });

            // Show options button.
            widget.find('.show-options-btn').on('click', e => {
                const btn = $(e.currentTarget);
                btn.prop('disabled', true);
                btn.siblings('.show-view-btn').prop('disabled', false);
                changeView(widget, ['.options-wrapper'], ['.text-wrapper', '.results-wrapper'])
            });

            // Show latest round results button.
            widget.find('.show-latest-round-results-btn').on('click', e => {
                const btn = $(e.currentTarget);
                btn.prop('disabled', true);
                btn.siblings('.show-view-btn').prop('disabled', false);
                changeView(widget, ['.results-wrapper', '.latest-round-wrapper'], ['.options-wrapper', '.text-wrapper', '.follow-up-wrapper']);
                if (isNPS(widget)) {
                    drawNPSLatestRoundChart(widget);
                } else {
                    drawRadarChart(widget, widget.find('.latest-round-wrapper .radar'));
                }
            });

            // Show follow-up results button.
            widget.find('.show-follow-up-results-btn').on('click', e => {
                const btn = $(e.currentTarget);
                btn.prop('disabled', true);
                btn.siblings('.show-view-btn').prop('disabled', false);
                changeView(widget, ['.results-wrapper', '.follow-up-wrapper'], ['.options-wrapper', '.text-wrapper', '.latest-round-wrapper']);
                if (isNPS(widget)) {
                    drawNPSFollowUpChart(widget);
                } else {
                    drawFollowUpCharts(widget);
                }
            });

            // Sort answers buttons.
            widget.find('.sort-answers-btn').on('click', e => {
                const btn = $(e.currentTarget);

                const dataPayload = {
                    sort_order : btn.data('sort-order')
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type : 'POST',
                    data : JSON.stringify(dataPayload),
                    success : function() {
                        changeView(widget, ['.results-wrapper'], ['.text-wrapper', '.options-wrapper'])
                        changeView(widget, ['.latest-round-wrapper'], ['.follow-up-wrapper']);
                    }
                });
            });

            // Slider input.
            widget.find('.options-wrapper .howspace-slider').on(howspace.components.slider.SLIDER_VALUE_CHANGE, () => {
                setSelectedAnswers(widget);
            });

            // Submit answers.
            widget.find('.submit-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn);

                submitAnswer(widget, () => {
                    real.button.reset(btn);
                });
            });

            // Remove answers.
            widget.find('.delete-answer-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn);

                deleteAnswer(widget, () => {
                    removeSelectedAnswers(widget);
                });
            });

            // Change answers.
            widget.find('.change-answer-btn').on('click', e => {
                getSelectedAnswers(widget);
                changeView(widget, ['.options-wrapper'], ['.text-wrapper', '.results-wrapper'])
                widget.find('.options-wrapper .howspace-slider-input').first().trigger('focus');
            });

            if (widget.find('.options-wrapper').is(':visible')) {
                // Restore user selections from local storage.
                getSelectedAnswers(widget);
            }

            // Legend badges.
            widget.on('click', '.average-badge', toggleLatestRoundAverage);
            widget.on('keydown', '.average-badge', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    toggleLatestRoundAverage(e);
                    return false;
                }
            });

            widget.on('click', '.my-answer-badge', toggleLatestRoundMyAnswer);
            widget.on('keydown', '.my-answer-badge', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    toggleLatestRoundMyAnswer(e);
                    return false;
                }
            });

            widget.on('click', '.filter-badge', toggleFilterAverage);
            widget.on('keydown', '.filter-badge', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    toggleFilterAverage(e);
                    return false;
                }
            });

            // Remove comparison button.
            widget.find('.remove-comparison-btn').on('click', () => {
                const dataPayload = {
                    compare: null
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type : 'POST',
                    data : JSON.stringify(dataPayload)
                });
            });

            // Distribution modal.
            widget.on('click', '.distribution', (e) => {
                const distribution = $(e.currentTarget);
                howspace.components.modal.show(howspace.widgets.getUrl(widget) + '/distribution-modal', (modal) => {
                    initDistributionModal(modal, distribution);
                });
            });
            widget.on('keydown', '.distribution', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    const distribution = $(e.currentTarget);
                    howspace.components.modal.show(howspace.widgets.getUrl(widget) + '/distribution-modal', (modal) => {
                        initDistributionModal(modal, distribution);
                    });
                    return false;
                }
            });
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Scale type radio buttons.
            widget.find('input[data-name="scale_type"]').on('change', e => {
                if ($(e.currentTarget).val() === howspace.widgets.pulse.SCALE_TYPE_NPS) {
                    // disable adding questions
                    widget.find('.add-question-btn').prop('disabled', true);
                    widget.find('.add-question-btn').addClass('d-none');

                    // add default eNPS question if missing
                    if (widget.find('.question-sortable-list .question').length === 0) {
                        const question = howspace.components.sortableList.addItem(widget.find('.question-sortable-list'));
                        question.find('.title').val(howspace.translate('pulse_question_title_enps'));
                        question.find('.is-enabled').addClass('disabled').find('input').prop('disabled', true);
                        question.find('.btn').prop('disabled', true);
                    } else {
                        const questions = widget.find('.question-sortable-list .question');
                        questions.find('.is-enabled').addClass('disabled').find('input').prop('disabled', true);
                        questions.find('.btn').prop('disabled', true);

                        if (!widget.data('has-questions')) {
                            questions.first().find('.title').val(howspace.translate('pulse_question_title_enps'));
                        }
                    }

                    // hide irrelevant settings
                    widget.find('.results-settings-wrapper').velocity('slideUp',
                        howspace.getAnimationDuration(widget, '--animation-duration'));

                    // disable change own answer
                    widget.find('input[name="user_can_change_own_answer"]').prop('checked', false);

                    // enable permanent anonymity
                    widget.find('input[name="permanently_anonymous"]').prop('checked', true);
                } else {
                    // enable adding questions
                    widget.find('.add-question-btn').prop('disabled', false);
                    widget.find('.add-question-btn').removeClass('d-none');

                    // enable editing questions
                    const questions = widget.find('.question-sortable-list .question');
                    questions.find('.is-enabled').removeClass('disabled').find('input').prop('disabled', false);
                    questions.find('.btn').prop('disabled', false);

                    // show all settings
                    widget.find('.results-settings-wrapper').velocity('slideDown',
                        howspace.getAnimationDuration(widget, '--animation-duration'));

                    if (!widget.data('has-questions')) {
                        questions.first().find('.title').val('');
                    }
                }
            });

            widget.find('input[name="permanently_anonymous"]').on('change', e => {
                const filterInput = widget.find('input[name="is_filter_shown_to_participants"]');
                const filterLabel = filterInput.closest('.howspace-form-label');
                if ($(e.currentTarget).is(':checked')) {
                    if (filterInput.is(':checked')) {
                        filterInput.trigger('click');
                    }
                    howspace.components.toolTip.update(filterLabel, howspace.translate('pulse_is_filter_shown_to_participants_disabled_tooltip'));
                    howspace.components.toolTip.enable(filterLabel);
                    howspace.form.disable(filterLabel);
                } else {
                    howspace.form.enable(filterLabel);
                    howspace.components.toolTip.disable(filterLabel);
                }
            });

            // Add question button.
            widget.find('.add-question-btn').on('click', e => {
                howspace.components.sortableList.addItem(widget.find('.question-sortable-list'));
            });

            // Add answering round button.
            widget.find('.add-answering-round-btn').on('click', _e => {
                const sortableList = widget.find('.answering-round-sortable-list');
                howspace.components.sortableList.addItem(sortableList,
                    { number : sortableList.find('.answering-round').length + 1 });
            });

            // Add first question.
            if(widget.find('.question-sortable-list .question').length === 0) {
                widget.find('.add-question-btn').trigger('click');
            }

            // Add first answering round.
            if (widget.find('.answering-rounds .answering-round').length === 0) {
                widget.find('.add-answering-round-btn').trigger('click');
            }

            // Scale type input.
            widget.find('.howspace-range-input-left').on('input', updateLegend);
            widget.find('.howspace-range-input-right').on('input', updateLegend);

            if (widget.find('input[data-name="scale_type"]:checked').val() === howspace.widgets.pulse.SCALE_TYPE_NPS) {
                const questions = widget.find('.question-sortable-list .question');
                questions.find('.is-enabled').addClass('disabled').find('input').prop('disabled', true);
                questions.find('.btn').prop('disabled', true);
            }
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            // Questions.
            dataPayload.questions = [];
            widget.find('.question:not(.deleted)').each(function() {
                dataPayload.questions.push(real.form.getDataPayload($(this)));
            });

            // Answering rounds.
            dataPayload.answering_rounds = [];
            widget.find('.answering-round:not(.deleted)').each(function() {
                dataPayload.answering_rounds.push(real.form.getDataPayload($(this)));
            });

            // Scale legend.
            const scaleType = widget.find('input[data-name="scale_type"]:checked').val();
            dataPayload.scale_legend = {};
            widget.find('.legend-item[data-scale-type="' + scaleType + '"]:not(.d-none)').each(function() {
                const index = $(this).data('index').toString();
                const input = $(this).find('input');

                dataPayload.scale_legend[index] = input.val();
            });

            return dataPayload;
        },
        initComparisonModal : (modal, modalOpener) => {
            modal = $(modal);
            modal.find('.compare-btn').on('click', e => {
                const btn = $(e.currentTarget);
                const compare = btn.data('compare');
                const widget = $(modalOpener).closest('.widget');

                if (widget.data('compare-results-to') !== compare) {
                    const dataPayload = {
                        filter: null,
                        compare: compare
                    };

                    real.ajax.json(howspace.widgets.getApiUrl(widget), {
                        type : 'POST',
                        data : JSON.stringify(dataPayload)
                    });
                }

                howspace.components.modal.close(modal);
            });
        },
        updateFilter : (widget) => {
            widget.find('.comparison-info').addClass('d-none');
            widget.removeDataAndAttr('compare-results-to');

            updateResultsView(widget);
        },
        saveFilter : (widget, dataPayload) => {
            dataPayload.compare = null;

            return dataPayload;
        }
    };
})();
